import { userTypes } from "../enums/userTypes";

const fixJsonString = (str) => {
    return str.replace(/'/g, '"').replace(/,(\s*])/, '$1');
}

const getUserType = (user, isStudent) => {
    if (isStudent)
        return userTypes.student;
    else if (user?.roles) {
        const roles = user.roles;
        const parsedRoles = Array.isArray(roles) ? roles : JSON.parse(fixJsonString(roles));
        const roleIds = parsedRoles?.map(r => r.role);

        if (window.config?.adminRoles?.some(id => roleIds.includes(id)))
            return userTypes.admin;
        else if (window.config?.teacherRoles?.some(id => roleIds.includes(id)))
            return userTypes.teacher;
        return null;
    }
}

export const getClassRange = (userDetails) => {
    const defaultSchool = userDetails?.defaultSchool;
    if (!defaultSchool)
        return Array.from({ length: 12 }, (_, i) => String(i + 1));
    const from = parseInt(defaultSchool.fromClass, 10);
    const to = parseInt(defaultSchool.toClass, 10);
    if ((!from || from === 0) && (!to || to === 0))
        return Array.from({ length: 12 }, (_, i) => String(i + 1));
    if (isNaN(from) && isNaN(to)) return;
    if (!isNaN(from) && isNaN(to)) return [String(from)];
    if (isNaN(from) && !isNaN(to)) return [String(to)];
    if (from > to) return;
    const allClasses = Array.from({ length: to - from + 1 }, (_, i) => String(from + i));
    const uniqueSorted = [...new Set(allClasses)].sort((a, b) => Number(a) - Number(b));
    return uniqueSorted;
}

export const getUserAllSchoolProperty = (userDetails, property) => {
    if (!userDetails?.defaultSchool)
        return null;
    const value = userDetails.defaultSchool[property];
    return value != null ? [value] : null;
};

export const processUserDetails = (userDetails, user, isStudent) => {
    const userProcessed = { ...user, ...userDetails, ...isStudent };
    userProcessed.userType = getUserType(user, isStudent);
    userProcessed.classRange = getClassRange(userDetails);
    return userProcessed
}